/* eslint-disable */

/**
 * Formats a currency according to the user's locale
 * @param {string} currency The ISO currency code
 * @param {number} value The amount to format
 * @returns
 */
export const formatPrice = (currency = 'USD', value = 0, fraction = 2, locale = 'en-US') => {
	return Intl.NumberFormat(locale, {
		currency,
		style: 'currency',
		minimumFractionDigits: fraction,
	}).format(value);
};

export const getCurrencySymbol = (currency, locale = undefined) => {
	if (!currency) {
		return;
	}

	const formatter = Intl.NumberFormat(locale, {
		currency,
		style: 'currency',
	});
	const parts = formatter.formatToParts(100);
	const { value: symbol } = parts.find(part => { return part.type === 'currency'; });
	const formatted = formatter.format(100);
	const symbolAtEnd = formatted.endsWith(symbol);
	return { symbol, symbolAtEnd };
};
